export default __webpack_public_path__ + "73d13255b59b75ce7aac90236e854bc1.png";